import { AuthClient } from "../data/auth-client";

async function ResetPassword(token, password) {
  try {
    const authClient = new AuthClient();

    // Call the backend with the token and password
    const response = await authClient.resetPassword(token, password);

    // If the backend responds successfully, return the response
    return response;
  } catch (err) {
    console.error("Error en resetPassword:", err);
    throw err; // Rethrow error for frontend to handle
  }
}

export default ResetPassword;
